import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

import { PRODUCT_KEY } from "./keys";

import { EditProduct, UpdateProductStock } from "@/types";
import { ProductRepository } from "@/repositories/product";

export const useEditProduct = () => {
  const queryClient = useQueryClient();
  const productRepository = useRef(new ProductRepository());

  return useMutation({
    mutationFn: async (data: EditProduct) => {
      return await productRepository.current.update(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate(query) {
          return query.queryKey.includes(PRODUCT_KEY);
        },
      });
    },
  });
};

export const useUpdateProductStock = () => {
  const queryClient = useQueryClient();
  const productRepository = useRef(new ProductRepository());

  return useMutation({
    mutationFn: async (data: UpdateProductStock) => {
      return await productRepository.current.updateStock(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate(query) {
          return query.queryKey.includes(PRODUCT_KEY);
        },
      });
    },
  });
};
